import { z } from 'zod'
import type { IntlShape } from 'react-intl'
import { getRequiredFields } from 'util/getZodSchemaRequiredFields'

const meterInvoicingFormSchema = z.object({
	companyUUID: z.string().trim(),
	description: z.string().trim(),
	invoiceDate: z.string().trim(),
	dueDate: z.string().trim(),
	invoicePeriodStartDate: z.string().trim(),
	invoicePeriodEndDate: z.string().trim(),
	additionalInformation: z.string().trim().optional(),

	paymentProductUUIDs: z.array(z.string().trim()),
	contractUUIDs: z.array(z.string().trim()),
})

export const requiredFormFields = getRequiredFields(meterInvoicingFormSchema)

export const meterInvoiceFormSchemaLocalized = (intl: IntlShape) => {
	const s = meterInvoicingFormSchema
	return meterInvoicingFormSchema.extend({
		description: s.shape.description.min(1, {
			message: intl.formatMessage({
				defaultMessage: 'Selite / erillislaskun väliotsikko vaaditaan.',
				description: 'Error message for required description',
			}),
		}),
		invoiceDate: s.shape.invoiceDate.date(
			intl.formatMessage({
				defaultMessage: 'Laskupäivä vaaditaan.',
				description: 'Error message for required invoice date',
			}),
		),
		dueDate: s.shape.dueDate.date(
			intl.formatMessage({
				defaultMessage: 'Eräpäivä vaaditaan.',
				description: 'Error message for required due date',
			}),
		),
		invoicePeriodStartDate: s.shape.invoicePeriodStartDate.date(
			intl.formatMessage({
				defaultMessage: 'Laskutusjakso alkupäivä vaaditaan.',
				description: 'Error message for required  invoice period start date',
			}),
		),
		invoicePeriodEndDate: s.shape.invoicePeriodEndDate.date(
			intl.formatMessage({
				defaultMessage: 'Laskutusjakso loppupäivä vaaditaan.',
				description: 'Error message for required invoice period end date',
			}),
		),
		paymentProductUUIDs: s.shape.paymentProductUUIDs.min(1, {
			message: intl.formatMessage({
				defaultMessage: 'Valitse vähintään yksi maksulaji.',
				description: 'Error message for required payment product',
			}),
		}),
		contractUUIDs: s.shape.contractUUIDs.min(1, {
			message: intl.formatMessage({
				defaultMessage: 'Valitse vähintään yksi sopimus.',
				description: 'Error message for required conrtract.',
			}),
		}),
	})
}

export const meterInvoicingBasicInformationFormSchema = (intl: IntlShape) =>
	meterInvoiceFormSchemaLocalized(intl).pick({
		description: true,
		invoiceDate: true,
		dueDate: true,
		invoicePeriodStartDate: true,
		invoicePeriodEndDate: true,
		additionalInformation: true,
	})

export const meterInvoicingPaymentProductFormSchema = (intl: IntlShape) =>
	meterInvoiceFormSchemaLocalized(intl).pick({
		paymentProductUUIDs: true,
	})

export const meterInvoicingContractFormSchema = (intl: IntlShape) =>
	meterInvoiceFormSchemaLocalized(intl).pick({
		contractUUIDs: true,
	})
